<div class="wrapper">
  <div class="image-container" (wheel)="onWheel()" #imageContainer></div>
  <div class="top-bar d-flex align-items-center justify-content-between">
    <div class="page-button-container d-flex align-items-center ">
      <button
        mat-icon-button
        aria-label="Previous Page"
        [disabled]="!stepBackwardEnabled"
        (click)="prevPage()"
        class="action-icon"
      >
        <mat-icon>navigate_before</mat-icon>
      </button>
      <button
        mat-icon-button
        aria-label="Next Page"
        [disabled]="!stepForwardEnabled"
        (click)="nextPage()"
        class="action-icon"
      >
        <mat-icon>navigate_next</mat-icon>
      </button>
      <div class="paging d-flex align-items-center">
        <input
          type="number"
          class="toolbar-field page-number"
          [(ngModel)]="page"
          (blur)="changePage()"
          size="4"
        />
        &nbsp;of {{ totalPages }}
      </div>
    </div>
    <div class="zoom-button-container">
      <button
        mat-icon-button
        aria-label="Zoom In"
        [disabled]="!zoomInEnabled"
        (click)="zoomIn()"
        class="action-icon"
      >
        <mat-icon>zoom_in</mat-icon>
      </button>
      <button
        mat-icon-button
        aria-label="Zoom Out"
        [disabled]="!zoomOutEnabled"
        (click)="zoomOut()"
        class="action-icon"
      >
        <mat-icon>zoom_out</mat-icon>
      </button>
      <button
        mat-icon-button
        aria-label="Reset Zoom"
        [disabled]="!zoomOutEnabled"
        (click)="resetZoom()"
        class="action-icon"
      >
        <mat-icon>zoom_out_map</mat-icon>
      </button>
    </div>
    <div class="rotate-button-container">
      <button mat-icon-button aria-label="Rotate Right" (click)="rotateRight()" class="action-icon">
        <mat-icon>rotate_right</mat-icon>
      </button>
      <button mat-icon-button aria-label="Rotate Left" (click)="rotateLeft()" class="action-icon">
        <mat-icon>rotate_left</mat-icon>
      </button>
    </div>
  </div>
</div>
